function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.15743 0 0 .13422 -4.6128 -6.8322)"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#000"
}, /*#__PURE__*/React.createElement("path", {
  transform: "scale(.26458)",
  d: "m125.71 200v514.29h42.857v-428.35l89.986 155.86 37.211-21.484-127.2-220.31z",
  fill: "#011d36",
  strokeWidth: 0.37795
}), /*#__PURE__*/React.createElement("path", {
  transform: "scale(.26458)",
  d: "m515.18 200-127.2 220.31 37.213 21.484 89.986-155.86v428.35h42.857v-514.29z",
  fill: "#021e39",
  strokeWidth: 0.37795
}), /*#__PURE__*/React.createElement("path", {
  d: "m92.216 114.72a33.234 33.234 0 0 0-33.145 33.234 33.234 33.234 0 0 0 33.234 33.234 33.234 33.234 0 0 0 18.425-5.5748 33.234 33.234 0 0 1-9.1989-9.1829 20.651 20.651 0 0 1-9.2258 2.1756 20.651 20.651 0 0 1-20.651-20.651 20.651 20.651 0 0 1 20.645-20.651 20.651 20.651 0 0 1 0.0067 0 20.651 20.651 0 0 1 9.2258 2.1756 33.234 33.234 0 0 1 9.1989-9.1829 33.234 33.234 0 0 0-18.425-5.5749 33.234 33.234 0 0 0-0.08888 0z",
  fill: "#021e39",
  strokeWidth: 0.12898
})), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "m92.216 114.72a33.234 33.234 0 0 0-33.145 33.234 33.234 33.234 0 0 0 33.234 33.234 33.234 33.234 0 0 0 18.425-5.5748 33.234 33.234 0 0 1-9.1989-9.1829 20.651 20.651 0 0 1-9.2258 2.1756 20.651 20.651 0 0 1-20.651-20.651 20.651 20.651 0 0 1 20.645-20.651 20.651 20.651 0 0 1 0.0067 0 20.651 20.651 0 0 1 9.2258 2.1756 33.234 33.234 0 0 1 9.1989-9.1829 33.234 33.234 0 0 0-18.425-5.5749 33.234 33.234 0 0 0-0.08888 0z",
  stroke: "#ff6900",
  strokeOpacity: 0.95161,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  transform: "scale(.26458)",
  d: "m515.18 200-127.2 220.31 37.213 21.484 89.986-155.86v428.35h42.857v-514.29z",
  stroke: "#ff6900",
  strokeOpacity: 0.95294,
  strokeWidth: 7.5591
}), /*#__PURE__*/React.createElement("path", {
  transform: "scale(.26458)",
  d: "m125.71 200v514.29h42.857v-428.35l89.986 155.86 37.211-21.484-127.2-220.31z",
  stroke: "#f46401",
  strokeOpacity: 0.99608,
  strokeWidth: 7.5591
})));

var SvgBrand = function SvgBrand(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBrand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/brand.b9d7a2fe.svg";
export { ForwardRef as ReactComponent };